import { MeterRow } from '@contracts';

export function mapMeterRows(values: any[]): MeterRow[] {
  return values.map((value) => ({
    ...value,
    sensor_id: value.id,
    // tags: Array.isArray(value.tags) ? value.tags.join(' , ') : value.tags,
  }));
}
